import { DatePicker, Flex, Select, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { DateRangeFilterRangeType } from '../../../../data/filters/dateRangeFilter';
import { maxCustomRangeDate, minCustomRangeDate, optionsRangeType } from './FilterDateRange.constants';
import { useDateRangeFilter } from './FilterDateRange.hooks';
import { messages } from './FilterDateRange.messages';
import { FilterDateRangeProps } from './FilterDateRange.types';

export const FilterDateRange = memo<FilterDateRangeProps>((props) => {
    const { filter, onFilterChange } = props;

    const { dateFrom, dateTo, rangeType, handleChangeRangeType, handleChangeGreaterOrEqual, handleChangeLessOrEqual } =
        useDateRangeFilter(filter, onFilterChange);

    if (!rangeType) {
        return null;
    }

    return (
        <Flex spacing='8'>
            <Flex width={167} shrink={0} grow={0}>
                <Select
                    size='small'
                    itemIdKey='id'
                    itemNameKey='text'
                    clearable={false}
                    value={rangeType?.id || undefined}
                    items={optionsRangeType}
                    onChange={handleChangeRangeType}
                    autocomplete
                />
            </Flex>

            {filter.rangeType === DateRangeFilterRangeType.Custom && (
                <Flex spacing='4' alignItems='baseline' shrink={0} grow={1}>
                    <Text font='label' fontSize='small' color='midnight70'>
                        {messages.from}
                    </Text>

                    <Flex width={128}>
                        <DatePicker
                            size='small'
                            value={dateFrom}
                            onChange={handleChangeGreaterOrEqual}
                            placeholder={messages.from}
                            minDate={minCustomRangeDate}
                            maxDate={dateTo || maxCustomRangeDate}
                        />
                    </Flex>

                    <Text font='label' fontSize='small' color='midnight70'>
                        {messages.to}
                    </Text>

                    <Flex width={128}>
                        <DatePicker
                            size='small'
                            value={dateTo}
                            onChange={handleChangeLessOrEqual}
                            placeholder={messages.to}
                            minDate={dateFrom || minCustomRangeDate}
                            maxDate={maxCustomRangeDate}
                        />
                    </Flex>
                </Flex>
            )}
        </Flex>
    );
});

FilterDateRange.displayName = 'FilterDateRange';
